import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'od-svg-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
})
export class SvgIconComponent {
  name = input.required<string>();
  parentSize = input(false);
  limitSize = input(false);
}
